export const fdefObjekt = {
  formdefinition: [
    {
      control: "input",
      name: "label_vertrag",
      label: "Vertrag",
      cols: "12",
      disabled: "true",
    },
    /*
    {
      control: "input",
      name: "typ",
      label: "Typ",
      cols: "12",
    },*/
    {
      control: "input",
      name: "bezeichnung",
      label: "Bezeichnung",
      cols: "12",
      valid: "isNotEmpty(item)",
    },
    {
      control: "input",
      name: "strasse",
      label: "Strasse",
      cols: "8",
    },
    {
      control: "input",
      name: "hausnr",
      label: "Hausnummer",
      cols: "2",
    },
    {
      control: "input",
      name: "plz",
      label: "PLZ",
      cols: "4",
    },
    {
      control: "input",
      name: "ort",
      label: "Ort",
      cols: "8",
    },
    {
      control: "input",
      name: "customer_reference_number",
      label: "Wirtschaftseinheit",
      cols: "12",
    },
    {
      control: "datepicker",
      name: "beginn",
      label: "Beginn",
      cols: "6",
      disabled: "true",
    },
    {
      control: "datepicker",
      name: "ablauf", //person.dgebdat
      label: "Ablauf",
      cols: "6",
      disabled: "true",
    },
    {
      control: "expandable",
      name: "sparten",
      label: "Sparten",
      label_add: "neue Sparte",
      valid: "isSubFormValid(item)",
      allow_deletion: false,
      cols: "12",
      rowControls: [
        {
          control: "input",
          name: "id",
          label: "ID",
          cols: "12",
          hidden: "true",
        },
        {
          control: "input",
          name: "sparte",
          label: "Sparte",
          cols: "12",
          valid: "isNotEmpty(item)",
        },
        {
          control: "datepicker",
          name: "zugang",
          label: "Zugang",
          cols: "3",
          default: new Date(),
        },
        {
          control: "datepicker",
          name: "abgang", //person.dgebdat
          label: "Abgang",
          cols: "3",
          default: new Date(2999, 11, 31),
        },

        {
          control: "numberinput", //immer 0
          unit_type: "currency",
          unit: "€",
          allow_negative: false,
          name: "jnetto",
          label: "Jahresnetto",
          cols: "3",
        },
        {
          control: "numberinput", //immer 0
          unit_type: "currency",
          unit: "€",
          allow_negative: false,
          name: "jbrutto",
          label: "Jahresbrutto",
          cols: "3",
        },
        {
          control: "numberinput", //immer 0
          unit_type: "currency",
          unit: "€",
          allow_negative: false,
          name: "sb_fix",
          label: "SB (Fix)",
          cols: "3",
        },
        {
          control: "numberinput", //immer 0
          unit_type: "percent",
          unit: "%",
          min: 0,
          max: 100,
          default: 0,
          allow_negative: false,
          name: "sb_prozent",
          label: "SB (prozentual)",
          cols: "3",
        },
        {
          control: "numberinput", //immer 0
          unit_type: "currency",
          unit: "€",
          default: 0,
          allow_negative: false,
          name: "sb_min",
          label: "SB (mininmal)",
          cols: "3",
        },
        {
          control: "numberinput", //immer 0
          unit_type: "currency",
          unit: "€",
          default: 0,
          allow_negative: false,
          name: "sb_max",
          label: "SB (maximal)",
          cols: "3",
        },
      ],
    },
  ],
  transformOut: [],
};

export const fdefObjektCreate = {
  formdefinition: [
    {
      control: "autocomplete",
      name: "vertrag_id", //person.cberufgr
      label: "Vertrag",
      valid: "isNotEmpty(item)",
      multiple: false,
      cols: "12",
      get_api: {
        target: "options",
        method: "get",
        endpoint: "data/vertrags_select",
      },
    },
    /*
    {
      control: "autocomplete",
      name: "bt_objekt_id_ov", //person.cberufgr
      label: "Objekt",
      valid: "isNotEmpty(item)",
      multiple: false,
      cols: "12",
      get_api: {
        target: "options",
        method: "get",
        endpoint: '"data/objekts_select/"+getValue("vertrag_id_ov")',
        eval_endpoint: true,
      },
    },
    {
      control: "input",
      name: "typ",
      label: "Typ",
      cols: "12",
    },*/
    {
      control: "input",
      name: "bezeichnung",
      label: "Bezeichnung",
      valid: "isNotEmpty(item)",
      cols: "12",
    },
    {
      control: "input",
      name: "strasse",
      label: "Strasse",
      cols: "8",
    },
    {
      control: "input",
      name: "hausnr",
      label: "Hausnummer",
      cols: "2",
    },
    {
      control: "input",
      name: "plz",
      label: "PLZ",
      cols: "4",
    },
    {
      control: "input",
      name: "ort",
      label: "Ort",
      cols: "8",
    },
    {
      control: "input",
      name: "customer_reference_number",
      label: "Wirtschaftseinheit",
      cols: "12",
    },
    {
      control: "datepicker",
      name: "beginn",
      label: "Beginn",
      cols: "6",
      disabled: "true",
    },
    {
      control: "datepicker",
      name: "ablauf", //person.dgebdat
      label: "Ablauf",
      cols: "6",
      disabled: "true",
    },
    {
      control: "expandable",
      name: "sparten",
      label: "Sparten",
      label_add: "neue Sparte",
      valid: "isSubFormValid(item)",
      allow_deletion: false,
      cols: "12",
      rowControls: [
        {
          control: "input",
          name: "id",
          label: "ID",
          cols: "12",
          hidden: "true",
        },
        {
          control: "input",
          name: "sparte",
          label: "Sparte",
          cols: "12",
          valid: "isNotEmpty(item)",
        },
        {
          control: "datepicker",
          name: "zugang",
          label: "Zugang",
          cols: "3",
          default: new Date(),
        },
        {
          control: "datepicker",
          name: "abgang", //person.dgebdat
          label: "Abgang",
          cols: "3",
          default: new Date(2999, 11, 31),
        },

        {
          control: "numberinput", //immer 0
          unit_type: "currency",
          unit: "€",
          allow_negative: false,
          name: "jnetto",
          label: "Jahresnetto",
          cols: "3",
        },
        {
          control: "numberinput", //immer 0
          unit_type: "currency",
          unit: "€",
          allow_negative: false,
          name: "jbrutto",
          label: "Jahresbrutto",
          cols: "3",
        },
        {
          control: "numberinput", //immer 0
          unit_type: "currency",
          unit: "€",
          allow_negative: false,
          name: "sb_fix",
          label: "SB (Fix)",
          cols: "3",
        },
        {
          control: "numberinput", //immer 0
          unit_type: "percent",
          unit: "%",
          min: 0,
          max: 100,
          default: 0,
          allow_negative: false,
          name: "sb_prozent",
          label: "SB (prozentual)",
          cols: "3",
        },
        {
          control: "numberinput", //immer 0
          unit_type: "currency",
          unit: "€",
          default: 0,
          allow_negative: false,
          name: "sb_fix",
          label: "SB (mininmal)",
          cols: "3",
        },
        {
          control: "numberinput", //immer 0
          unit_type: "currency",
          unit: "€",
          default: 0,
          allow_negative: false,
          name: "sb_fix",
          label: "SB (maximal)",
          cols: "3",
        },
      ],
    },
  ],
  transformOut: [
    {
      fn: "setConst",
      target: "bt_objekt_id_ov",
      value: null,
    },
  ],
};
